import React, { FC } from "react";

import { IconTooltip } from "~/components/atoms/IconTooltip";

type PropsType = {
  htmlFor: string;
  labelText: string;
  required: boolean;
  className?: string;
  tooltipText?: string;
};

export const Label: FC<PropsType> = ({
  htmlFor,
  labelText,
  required,
  className,
  tooltipText,
}: PropsType) => {
  return (
    <label
      htmlFor={htmlFor}
      className={`text-secondary-600 inline-flex items-center ${
        required && "after:content-['*'] after:ml-0.5 after:text-red-500"
      } ${className}`}
    >
      {labelText}
      {tooltipText && <IconTooltip text={tooltipText} />}
    </label>
  );
};
